import * as recircFeedActions from './../action_creators/recirc_feed_action_creators';
import RecircFeedModel from '../../models/recirc_module';
import log from '../../services/logger_service';

export default function fetchRecircModule(params, store) {
  return function firstDispatchRecirc(dispatch) {
    dispatch(recircFeedActions.recircFeedLoading({}, store));
    return RecircFeedModel.fetch(params, store)
      .then(function handleRecircModuleData(resp) {
        dispatch(recircFeedActions.recircFeedLoaded(resp.data, store));
      })
      .catch(function handleRecircError(err) {
        dispatch(recircFeedActions.recircFeedLoadError(err, store));
        log.error(err, `Error in recirc feed actions, message: ${err.message}`);
      });
  };
}

export function hideRecircAction(dispatch) {
  return function hide() {
    dispatch(recircFeedActions.hideRecircFeed());
  };
}
